export default __webpack_public_path__ + "static/media/logo.066dcf92.png";